import Swiper from "swiper/bundle";
import constants from "../lib/constants";

export default class {
  constructor(element) {
    if (!element) {
      return false;
    }

    this.wrap = jQuery(element);
    this.slider = this.wrap.find('.s-net-price__items')
    this.pagination = this.wrap.find('.swiper-pagination')

    this._iniSlider()
    console.log('this.wrap', this.wrap)
  }


 

  _iniSlider() {
    this.swiper = new Swiper(this.slider[0], {    
      spaceBetween:12,     
      // autoplay: {
      //   delay: 4000,
      // },
      pagination: {       
        clickable: true,
        el: this.pagination[0],
      },
      breakpoints: {
        320:{
          slidesPerView:1
         },
         780:{
          slidesPerView:3
         },
        1520: {
          slidesPerView: "auto",
        },
      },
    });
  }
}
